/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './ReplyRecommendationsSettingsService';
import * as Queries from './ReplyRecommendationsSettingsService.dfc.new';
import type { AdditionalContextArgs } from './ReplyRecommendationsSettingsService.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseUpdateSettingsV2MutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.UpdateSettingsV2ResponseType>,
    References.UpdateSettingsV2RequestType,
    T extends true
      ? Record<'updateSettingsV2', References.UpdateSettingsV2ResponseType>
      : References.UpdateSettingsV2ResponseType
  >;

export function useUpdateSettingsV2Mutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.UpdateSettingsV2ResponseType>,
    References.UpdateSettingsV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseUpdateSettingsV2MutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.UPDATE_SETTINGS_V2_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            updateSettingsV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseUpdateSettingsV2MutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseUpdateSettingsV2MutationReturn<T>;
}

type UseGetSettingsQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetSettingsResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getSettings', References.GetSettingsResponseType>
        : References.GetSettingsResponseType)
    | undefined;
};

export function useGetSettingsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSettingsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSettingsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_SETTINGS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSettings: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetSettingsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetSettingsQueryReturn<T>;
}

type UseGetSettingsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSettingsResponseType>,
    {},
    T extends true
      ? Record<'getSettings', References.GetSettingsResponseType>
      : References.GetSettingsResponseType
  >;

export function useGetSettingsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSettingsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSettingsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SETTINGS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSettings: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSettingsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSettingsLazyQueryReturn<T>;
}

type UseGetSettingsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<Record<'result', References.GetSettingsResponseType>>,
  'data'
> & {
  data: T extends true
    ? Record<'getSettings', References.GetSettingsResponseType>
    : References.GetSettingsResponseType;
};

export function useGetSettingsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSettingsResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSettingsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SETTINGS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSettings: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSettingsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSettingsSuspenseQueryReturn<T>;
}

type UseGetSettingsV2QueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.GetSettingsV2ResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getSettingsV2', References.GetSettingsV2ResponseType>
        : References.GetSettingsV2ResponseType)
    | undefined;
};

export function useGetSettingsV2Query<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetSettingsV2ResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSettingsV2QueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_SETTINGS_V2_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSettingsV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSettingsV2QueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetSettingsV2QueryReturn<T>;
}

type UseGetSettingsV2LazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetSettingsV2ResponseType>,
    {},
    T extends true
      ? Record<'getSettingsV2', References.GetSettingsV2ResponseType>
      : References.GetSettingsV2ResponseType
  >;

export function useGetSettingsV2LazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetSettingsV2ResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSettingsV2LazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SETTINGS_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getSettingsV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetSettingsV2LazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetSettingsV2LazyQueryReturn<T>;
}

type UseGetSettingsV2SuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetSettingsV2ResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getSettingsV2', References.GetSettingsV2ResponseType>
    : References.GetSettingsV2ResponseType;
};

export function useGetSettingsV2SuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetSettingsV2ResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetSettingsV2SuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SETTINGS_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getSettingsV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetSettingsV2SuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetSettingsV2SuspenseQueryReturn<T>;
}

type UseAreReplyRecsEnabledQueryReturn<T extends boolean> = Omit<
  QueryResult<Record<'result', References.AreReplyRecsEnabledResponseType>>,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'areReplyRecsEnabled',
            References.AreReplyRecsEnabledResponseType
          >
        : References.AreReplyRecsEnabledResponseType)
    | undefined;
};

export function useAreReplyRecsEnabledQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.AreReplyRecsEnabledResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAreReplyRecsEnabledQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.ARE_REPLY_RECS_ENABLED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            areReplyRecsEnabled: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseAreReplyRecsEnabledQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseAreReplyRecsEnabledQueryReturn<T>;
}

type UseAreReplyRecsEnabledLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.AreReplyRecsEnabledResponseType>,
    {},
    T extends true
      ? Record<
          'areReplyRecsEnabled',
          References.AreReplyRecsEnabledResponseType
        >
      : References.AreReplyRecsEnabledResponseType
  >;

export function useAreReplyRecsEnabledLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.AreReplyRecsEnabledResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAreReplyRecsEnabledLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.ARE_REPLY_RECS_ENABLED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            areReplyRecsEnabled: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseAreReplyRecsEnabledLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseAreReplyRecsEnabledLazyQueryReturn<T>;
}

type UseAreReplyRecsEnabledSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.AreReplyRecsEnabledResponseType>
  >,
  'data'
> & {
  data: T extends true
    ? Record<'areReplyRecsEnabled', References.AreReplyRecsEnabledResponseType>
    : References.AreReplyRecsEnabledResponseType;
};

export function useAreReplyRecsEnabledSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.AreReplyRecsEnabledResponseType>
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseAreReplyRecsEnabledSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.ARE_REPLY_RECS_ENABLED_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            areReplyRecsEnabled: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseAreReplyRecsEnabledSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseAreReplyRecsEnabledSuspenseQueryReturn<T>;
}
